import { gql } from 'urql';

const GET_OPPORTUNITIES_VIEWS = gql`
  query GetUserOpportunityVisits($where: user_opportunity_visit_bool_exp) {
    user_opportunity_visit(where: $where) {
      user_id
      company_id
      teams_id
      opportunity_id
      last_visit_at
    }
  }
`;

export default GET_OPPORTUNITIES_VIEWS;
